import {createRouter, createWebHistory} from "vue-router";
import Login from "@/page/Login.vue";
import ErrorPage from "@/page/ErrorPage.vue";
import ChangePassword from "@/page/ChangePassword.vue";
import LayoutAuth from "@/components/layouts/Auth.vue";
import LayoutDashboard from "@/components/layouts/Dashboard.vue";
import LayoutError from "@/components/layouts/Error.vue";
import PasswordLayout from "@/components/layouts/ChangePasswordLayout.vue";
import createRole from "@/page/Role/CreateRole.vue";
// import homePage from "@/page/homePage.vue";
import AddNewPost from "@/page/post/AddNewPost.vue";
import AllPosts from "@/page/post/AllPosts.vue";
import AddUser from "@/page/user/AddUser.vue";
import ResetPassword from "@/page/user/ResetPassword.vue";
import AllUsers from "@/page/user/AllUsers.vue";
import Notification from "@/page/NotificationList.vue";
import UserProfile from "@/page/user/UserProfile.vue";
import selectableMedia from "@/components/Media/SelectableMedia.vue";
import showAllMedia from "@/components/Media/ShowAllMedia.vue";
import uploadMedia from "@/components/Media/UploadMedia.vue";
import portalFooter from "@/page/ThemeEditor/PortalFooter.vue";
import portalHeader from "@/page/ThemeEditor/PortalHeader.vue";
import InfoDashboardVue from "./page/DashboardMenu/InfoDashboard.vue";
import DashboardPage from "@/page/DashboardMenu/dashboardPage.vue";
import UserRoleAssign from "@/page/Role/UserRoleAssign.vue";
import AllPostCategories from "@/page/post/AllPostCategories.vue";
import EditPost from "@/page/post/EditPost.vue";
import UserHistory from "@/page/user/UserLoginHistory.vue";
//notice
import AddNewNotice from "@/page/Notice/AddNewNotice.vue";
import AllNotices from "@/page/Notice/AllNotices.vue";
import AllNoticeCategories from "@/page/Notice/AllNoticeCategories.vue";
import EditNotice from "@/page/Notice/EditNotice.vue";
// service
import AddNewService from "@/page/Service/AddNewService.vue";
import AllServices from "@/page/Service/AllServices.vue";
import AllServiceCategories from "@/page/Service/AllServiceCategories.vue";
import EditService from "@/page/Service/EditService.vue";
import videoContent from "@/page/ThemeEditor/Videos.vue";
import themeTypography from "@/page/ThemeEditor/ThemeTypography.vue";
// import emailTemplate from "@/page/ThemeEditor/EmailTemplate.vue";
//Law
import AddNewLaw from "@/page/Laws/AddNewLaw.vue";
import AllLaws from "@/page/Laws/AllLaws.vue";
import EditLaws from "@/page/Laws/EditLaws.vue";
import LawCategories from "@/page/Laws/AllLawCategories.vue";
//faq
import AddNewFAQ from "@/page/FAQ/AddNewFAQ.vue";
import AllFAQs from "@/page/FAQ/AllFAQs.vue";
import FAQCategories from "@/page/FAQ/AllFAQCategories.vue";
import EditFAQ from "@/page/FAQ/EditFAQ.vue";
//page
import AddNewPage from "@/page/Page/AddNewPage.vue";
import AllPages from "@/page/Page/AllPages.vue";
import AllPageCategories from "./page/Page/AllPageCategories.vue";
import EditPage from "@/page/Page/EditPage.vue";
//product
import AddNewProduct from "@/page/Product/AddNewProduct.vue";
import AllProducts from "@/page/Product/AllProducts.vue";
import AllProductCategories from "@/page/Product/AllProductCategories.vue";
import EditProduct from "@/page/Product/EditProduct.vue";
import PortalMainmenuConfig from "@/page/ThemeEditor/PortalMainmenuConfigPage.vue";
import Sidebar from "@/page/ThemeEditor/Sidebar.vue";
import RevisionPageVue from "@/page/Revision/RevisionPage.vue";
//Management
import AddNewManagement from "@/page/Management/AddNewManagement.vue";
import AllManagements from "@/page/Management/AllManagements.vue";
import AllManagementCategories from "@/page/Management/AllManagementCategories.vue";
import EditManagement from "@/page/Management/EditManagement.vue";

//album
import CreateAlbum from "@/page/Album/CreateAlbum.vue";
import ShowAlbums from "@/page/Album/ShowAlbums.vue";
import EditAlbum from "@/page/Album/EditAlbum.vue";

//system settings
import SystemSettings from "@/page/SystemSettings/SystemSettings.vue";
import {notify} from "@kyvg/vue3-notification";
import PopupModal from "./page/PopupModal/PopupModalPage.vue";
import emailTemplate from "@/page/ThemeEditor/EmailTemplate.vue";
import PluginPage from "@/page/PluginPage.vue";
import PopupDetailsPage from "@/page/PopupModal/EditPopupPage.vue";
import AddPopupModalPage from "@/page/PopupModal/AddPopupModalPage.vue";
import ActivityLogPage from "@/page/ActivityLogPage.vue";
import ForgetPasswordPage from "@/page/ForgetPasswordPage.vue";
import EmployeeInfoPage from "@/page/EmployeeInfoPage.vue";
import AllPollPage from "@/page/poll/AllPollPage.vue";
import EditPollPage from "@/page/poll/EditPollPage.vue";
import AddPollPage from "@/page/poll/AddPollPage.vue";

import PdfViewer from "@/page/PdfViewer.vue";

const routes = [
    {
        path: "/",
        name: "Login",
        meta: {layout: LayoutAuth},
        component: Login,
    },
    /*{
                        path: "/home-page",
                        name: "homePage",
                        meta: { layout: LayoutDashboard },
                        component: DashboardPage,
                    },*/
    {
        path: "/site-analytics",
        name: "homePage",
        meta: {layout: LayoutDashboard},
        component: InfoDashboardVue,
    },
    {
        path: "/upload-media",
        name: "uploadMedia",
        meta: {layout: LayoutDashboard},
        component: uploadMedia,
    },

    {
        path: "/posts/all",
        name: "posts",
        meta: {layout: LayoutDashboard},
        component: AllPosts,
    },
    {
        path: "/posts/add",
        name: "addPost",
        meta: {layout: LayoutDashboard},
        component: AddNewPost,
    },
    {
        path: "/posts/edit/:id",
        name: "editPost",
        meta: {layout: LayoutDashboard},
        component: EditPost,
        props: true,
    },
    {
        path: "/posts/categories",
        name: "postCategories",
        meta: {layout: LayoutDashboard},
        component: AllPostCategories,
    },
    {
        path: "/notices/all",
        name: "notices",
        meta: {layout: LayoutDashboard},
        component: AllNotices,
    },
    {
        path: "/notices/add",
        name: "addNotice",
        meta: {layout: LayoutDashboard},
        component: AddNewNotice,
    },
    {
        path: "/notices/edit/:id",
        name: "editNotice",
        meta: {layout: LayoutDashboard},
        component: EditNotice,
        props: true,
    },
    {
        path: "/notices/categories",
        name: "noticeCategories",
        meta: {layout: LayoutDashboard},
        component: AllNoticeCategories,
    },
    {
        path: "/activity-log",
        name: "activityLog",
        meta: {layout: LayoutDashboard},
        component: ActivityLogPage,
    },
    {
        path: "/services/all",
        name: "services",
        meta: {layout: LayoutDashboard},
        component: AllServices,
    },
    {
        path: "/services/add",
        name: "addService",
        meta: {layout: LayoutDashboard},
        component: AddNewService,
    },
    {
        path: "/services/edit/:id",
        name: "editService",
        meta: {layout: LayoutDashboard},
        component: EditService,
        props: true,
    },
    {
        path: "/services/categories",
        name: "serviceCategories",
        meta: {layout: LayoutDashboard},
        component: AllServiceCategories,
    },
    {
        path: "/laws/add",
        name: "addLaw",
        meta: {layout: LayoutDashboard},
        component: AddNewLaw,
    },
    {
        path: "/laws/all",
        name: "allLaws",
        meta: {layout: LayoutDashboard},
        component: AllLaws,
    },
    {
        path: "/laws/categories",
        name: "lawCategories",
        meta: {layout: LayoutDashboard},
        component: LawCategories,
    },
    {
        path: "/laws/edit/:id",
        name: "editLaws",
        meta: {layout: LayoutDashboard},
        component: EditLaws,
        props: true,
    },
    {
        path: "/products/all",
        name: "products",
        meta: {layout: LayoutDashboard},
        component: AllProducts,
    },
    {
        path: "/products/add",
        name: "addProduct",
        meta: {layout: LayoutDashboard},
        component: AddNewProduct,
    },
    {
        path: "/products/edit/:id",
        name: "editProduct",
        meta: {layout: LayoutDashboard},
        component: EditProduct,
        props: true,
    },
    {
        path: "/products/categories",
        name: "productCategories",
        meta: {layout: LayoutDashboard},
        component: AllProductCategories,
    },
    {
        path: "/faqs/add",
        name: "addFAQ",
        meta: {layout: LayoutDashboard},
        component: AddNewFAQ,
    },
    {
        path: "/faqs/all",
        name: "allFAQs",
        meta: {layout: LayoutDashboard},
        component: AllFAQs,
    },
    {
        path: "/faqs/edit/:id",
        name: "editFAQ",
        meta: {layout: LayoutDashboard},
        component: EditFAQ,
        props: true,
    },
    {
        path: "/faqs/categories",
        name: "faqCategories",
        meta: {layout: LayoutDashboard},
        component: FAQCategories,
    },
    {
        path: "/pages/all",
        name: "pages",
        meta: {layout: LayoutDashboard},
        component: AllPages,
    },
    {
        path: "/pages/add",
        name: "addPage",
        meta: {layout: LayoutDashboard},
        component: AddNewPage,
    },
    {
        path: "/pages/edit/:id",
        name: "editPage",
        meta: {layout: LayoutDashboard},
        component: EditPage,
        props: true,
    },
    {
        path: "/pages/categories",
        name: "pageCategories",
        meta: {layout: LayoutDashboard},
        component: AllPageCategories,
    },
    {
        path: "/managements/all",
        name: "managements",
        meta: {layout: LayoutDashboard},
        component: AllManagements,
    },
    {
        path: "/managements/add",
        name: "addManagement",
        meta: {layout: LayoutDashboard},
        component: AddNewManagement,
    },
    {
        path: "/managements/edit/:id",
        name: "editManagement",
        meta: {layout: LayoutDashboard},
        component: EditManagement,
        props: true,
    },
    {
        path: "/managements/categories",
        name: "managementCategories",
        meta: {layout: LayoutDashboard},
        component: AllManagementCategories,
    },
    {
        path: "/users/add",
        name: "addUser",
        meta: {layout: LayoutDashboard},
        component: AddUser,
    },
    {
        path: "/user-recycle-bin",
        name: "users",
        meta: {layout: LayoutDashboard},
        component: AllUsers,
    },
    {
        path: "/notification-list",
        name: "notification-list",
        meta: {layout: LayoutDashboard},
        component: Notification,
    },
    {
        path: "/users/profile",
        name: "userProfile",
        meta: {layout: LayoutDashboard},
        component: UserProfile,
    },
    {
        path: "/users/change-password",
        name: "changepassword",
        meta: {layout: LayoutDashboard},
        component: ResetPassword,
    },
    {
        path: "/show-all-media",
        name: "showAllMedia",
        meta: {layout: LayoutDashboard},
        component: showAllMedia,
    },
    {
        path: "/create-role",
        name: "createRole",
        meta: {layout: LayoutDashboard},
        component: createRole,
    },
    {
        path: "/selectable-media",
        name: "selectableMedia",
        meta: {layout: LayoutDashboard},
        component: selectableMedia,
    },
    {
        path: "/sidebar",
        name: "sidebar",
        meta: {layout: LayoutDashboard},
        component: Sidebar,
    },
    {
        path: "/portal-footer",
        name: "portalFooter",
        meta: {layout: LayoutDashboard},
        component: portalFooter,
    },
    {
        path: "/portal-mainmenu",
        name: "portalMenu",
        meta: {layout: LayoutDashboard},
        component: PortalMainmenuConfig,
    },
    {
        path: "/video-content",
        name: "videos",
        meta: {layout: LayoutDashboard},
        component: videoContent,
    },
    {
        path: "/theme-typography",
        name: "themeTypography",
        meta: {layout: LayoutDashboard},
        component: themeTypography,
    },
    {
        path: "/email-template",
        name: "emailTemplate",
        meta: {layout: LayoutDashboard},
        component: emailTemplate,
    },
    {
        path: "/portal-header",
        name: "portalHeader",
        meta: {layout: LayoutDashboard},
        component: portalHeader,
    },
    {
        path: "/popup-modal",
        name: "PopupModal",
        meta: {layout: LayoutDashboard},
        component: PopupModal,
    },
    {
        path: "/popup-modal/edit",
        name: "PopupModalDetails",
        meta: {layout: LayoutDashboard},
        component: PopupDetailsPage,
        props: true,
    },
    {
        path: "/popup-modal/add",
        name: "AddPopupModal",
        meta: {layout: LayoutDashboard},
        component: AddPopupModalPage,
    },
    {
        path: "/dashboard",
        name: "infoDashboard",
        meta: {layout: LayoutDashboard},
        component: DashboardPage,
    },
    {
        path: "/assign-role",
        name: "assignRole",
        meta: {layout: LayoutDashboard},
        component: UserRoleAssign,
    },
    {
        path: "/user-login-history",
        name: "userHistory",
        meta: {layout: LayoutDashboard},
        component: UserHistory,
    },
    {
        path: "/revision/:id",
        name: "revisionContent",
        meta: {layout: LayoutDashboard},
        component: RevisionPageVue,
        props: true,
    },
    {
        path: "/album/create",
        name: "createAlbum",
        meta: {layout: LayoutDashboard},
        component: CreateAlbum,
    },
    {
        path: "/album/show",
        name: "showAlbums",
        meta: {layout: LayoutDashboard},
        component: ShowAlbums,
    },
    {
        path: "/album/:id",
        name: "editAlbum",
        meta: {layout: LayoutDashboard},
        component: EditAlbum,
        props: true,
    },
    {
        path: "/system-settings",
        name: "systemSettings",
        meta: {layout: LayoutDashboard},
        component: SystemSettings,
    },
    {
        path: "/plugin",
        name: "plugins",
        meta: {layout: LayoutDashboard},
        component: PluginPage,
    },
    {
        path: "/:pathMatch(.*)*",
        name: "not-found",
        meta: {layout: LayoutError},
        component: ErrorPage,
    },
    {
        path: "/error",
        name: "not-found",
        meta: {layout: LayoutError},
        component: ErrorPage,
    },
    {
        path: "/changePassword",
        name: "changePassword",
        meta: {layout: PasswordLayout},
        component: ChangePassword,
    },
    {
        path: "/forgot-password",
        name: "forgotPassword",
        meta: {layout: LayoutAuth},
        component: ForgetPasswordPage,
    },
    {
        path: "/employee-info",
        name: "employeeInfo",
        meta: {layout: LayoutDashboard},
        component: EmployeeInfoPage,
    },
    {
        path: "/poll/all",
        name: "AllPolls",
        meta: {layout: LayoutDashboard},
        component: AllPollPage,
    },
    {
        path: "/poll/edit",
        name: "EditPoll",
        meta: {layout: LayoutDashboard},
        component: EditPollPage,
        props: true,
    },
    {
        path: "/poll/add",
        name: "AddPoll",
        meta: {layout: LayoutDashboard},
        component: AddPollPage,
    },
    {
        path: "/pdf-viewer",
        name: "pdfViewer",
        meta: {layout: LayoutDashboard},
        component: PdfViewer,
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    linkActiveClass: "", // active class for non-exact links.
    linkExactActiveClass: "active", // active class for *exact* links.
});

router.beforeEach((to, from, next) => {
    var permissions = {};
    permissions = JSON.parse(localStorage.getItem("permissions"));

    const publicPages = ["/", "/first-login", "/changePassword", "/forgot-password"];
    const publicPagesNames = [
        "revisionContent",
        "changepassword",
        "userProfile",
        "editAlbum",
        "not-found",
        "pdfViewer",
        // "infoDashboard"
    ];
    const adminAccessPageNames = [];

    const authRequired = !publicPages.includes(to.path);
    const loggedIn = JSON.parse(localStorage.getItem("user"));
    const permitted_routes = JSON.parse(localStorage.getItem("permitted_routes"));
    const user = JSON.parse(localStorage.getItem("user"));

    // console.log("to", to);

    if (authRequired && !loggedIn) {
        next("/");
    } else {
        if (publicPages.includes(to.path) || publicPagesNames.includes(to.name)) {
            // if public page is requested
            if (to.path == "/" && !loggedIn) {
                // if not logged in, forward to login page
                next();
            } else if (to.path == "/") {
                // if logged in, forward to dashboard page
                next("/dashboard");
            } else {
                // if logged in, forward
                next();
            }
        } else if (
            null != permissions &&
            permissions.SHOW_NOTIFICATIONS == "Y" &&
            to.name == "notification-list"
        ) {
            // if user has notification permission, can go to notifications page
            next();
        } else if (
            user.data.user_role_id.includes(1) &&
            adminAccessPageNames.includes(to.name)
        ) {
            // if user is admin, can go to admin accessible pages
            next();
        } else if (permitted_routes != null) {
            if (to.path.includes("edit")) {
                // if user wants to access any edit page, check if the parent page access is there
                var my_route_list = to.path.split("/");
                my_route_list = my_route_list.filter((i) => i != "");

                //parent page
                if (permitted_routes.includes("/" + my_route_list[0] + "/all")) {
                    next();
                } else if (permitted_routes.includes("/" + my_route_list[0])) {
                    next();
                } else {
                    notify({
                        type: "error",
                        title: "Error Page",
                        text: "You don't have permission to visit this page.",
                    });
                    next("/error");
                }
            } else {
                if (
                    (to.path != "/error" || to.name != "not-found") &&
                    !permitted_routes.includes(to.path.toString())
                ) {

                    // if the page is not error page, and user doesn't have access, show error page
                    notify({
                        type: "error",
                        title: "Error Page",
                        text: "You don't have permission to visit this page.",
                    });
                    next("/error");
                } else {
                    // if user has access, show page
                    next();
                }
            }
        } else {
            //if there is no permitted route available and user password is expired and user is not an SSO user, change password
            if (
                new Date(new Date().toISOString().split("T")[0]) >
                new Date(user.data.password_expiry_date) &&
                user.data.password_expiry_date !== null &&
                (user.data.user_source == null || user.data.user_source !== 'sso')
            ) {
                next("/changePassword");
            } else if (to.path === '/dashboard') {
                // if the page is dashboard after logging in, forward
                next();
            } else {
                // if there is no permitted route available, everything except whitelist should forward to error page
                notify({
                    type: "error",
                    title: "Error Page",
                    text: "You don't have permission to visit this page.",
                });
                next("/error");
            }

        }
    }
});
export default router;
